export default __webpack_public_path__ + "static/Ambit-Black-9f000a6972d3e42bf193a667f553bb39.woff2";